export class ClaimServicesConstants {
  public static readonly DRP = 'drp';
  public static readonly RENTAL = 'RENTAL';
}
